// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-dialog-content {
  padding: 0px 32px 32px 32px;
  margin: 0px;
}

.mat-mdc-dialog-title {
  display: flex;
  padding-left: 5%;
  padding-right: 5%;
  margin-bottom: 2rem;
}
.mat-mdc-dialog-title mat-icon {
  margin-top: 20px;
  cursor: pointer;
  margin-right: 3px;
}

.form-tab-group .container-tab-body {
  padding-top: 2rem;
}

.background-white {
  background-color: white;
}

.containerToggle {
  display: flex;
  flex-direction: row;
  gap: 5%;
  padding-bottom: 3%;
}

.example-spacer {
  flex: 1 1 auto;
}

.slideAdministrar {
  margin-bottom: 10px;
  font-weight: 500;
}

.fila1 {
  padding-left: 5%;
  padding-top: 5%;
}

h1 {
  font-size: x-large;
}

.col1 h1 {
  width: 100%;
  text-align: initial;
  color: #333;
  font-family: Roboto, Segoe UI, wf_segoe-ui_normal, helvetica, arial, sans-serif;
  /* font-size: 14px;*/
  font-size: 25px;
  display: ruby-text-container;
}

.col2,
.col3,
.col1-3,
.col4,
.col5,
.col6 {
  text-align: end;
  /*display: grid;
  float: right;
  border-bottom: 1px solid #cecece;*/
  cursor: pointer;
}

@media screen and (max-width: 990px) {
  .col1 h1 {
    font-size: 14px !important;
  }
}
table {
  width: 100%;
}

.mat {
  width: 100%;
  margin-bottom: 10px;
}

.animacion {
  width: 100%;
  height: 90px;
}

.ocultar {
  display: none !important;
}

.paginador {
  display: ruby-text !important;
  margin-left: 5%;
}

.tablaUsuarios {
  border: 1px solid #cecece;
}

.inputBusqueda {
  border-bottom: 2px solid #5b7f30;
}

.iconoBusqueda {
  color: #8bc34a;
  cursor: pointer;
  padding-left: 8px;
  width: 100%;
}

.matFile {
  width: 100%;
}

.titulotabla {
  text-align: center;
  color: #333;
  font-family: Roboto, Segoe UI, wf_segoe-ui_normal, helvetica, arial, sans-serif;
  display: ruby-text-container;
  width: 100%;
}

.divheader {
  width: 100%;
  text-align: start;
}

::ng-deep .mat-sort-header-button {
  width: 100% !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

::ng-deep .form-tab-group .mat-tab-body-wrapper {
  padding: 2.5rem 0 0;
}

::ng-deep .mat-mdc-tab-group.mat-mdc-tab-group-stretch-tabs > .mat-mdc-tab-header .mat-mdc-tab {
  font-size: 14px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/dialogs/modificar-municipio/modificar-municipio.component.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;EACA,WAAA;AACJ;;AACA;EACI,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAEJ;AADI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AAGR;;AAEI;EACI,iBAAA;AACR;;AAGA;EACI,uBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,OAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,mBAAA;EACA,WAAA;EACA,+EAAA;EACA,oBAAA;EACA,eAAA;EACA,4BAAA;AAAJ;;AAGA;;;;;;EAMI,eAAA;EACA;;oCAAA;EAGA,eAAA;AAAJ;;AAGA;EACI;IACI,0BAAA;EAAN;AACF;AAGA;EACI,WAAA;AADJ;;AAIA;EACI,WAAA;EACA,mBAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;AADJ;;AAIA;EACI,wBAAA;AADJ;;AAIA;EACI,6BAAA;EACA,eAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,gCAAA;AADJ;;AAIA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAIA;EACI,kBAAA;EACA,WAAA;EACA,+EAAA;EACA,4BAAA;EACA,WAAA;AADJ;;AAIA;EACI,WAAA;EACA,iBAAA;AADJ;;AAIA;EACI,sBAAA;AADJ;;AAQA;;EAEI,wBAAA;EACA,SAAA;AALJ;;AAUI;EACI,mBAAA;AAPR;;AAWA;EACI,0BAAA;AARJ","sourcesContent":[".mat-mdc-dialog-content {\r\n    padding: 0px 32px 32px 32px;\r\n    margin: 0px;\r\n}\r\n.mat-mdc-dialog-title {\r\n    display: flex;\r\n    padding-left: 5%;\r\n    padding-right: 5%;\r\n    margin-bottom: 2rem;\r\n    mat-icon {\r\n        margin-top: 20px;\r\n        cursor: pointer;\r\n        margin-right: 3px;\r\n    }\r\n}\r\n\r\n.form-tab-group {\r\n    .container-tab-body {\r\n        padding-top: 2rem;\r\n    }\r\n}\r\n\r\n.background-white {\r\n    background-color: white;    \r\n}\r\n\r\n.containerToggle{\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 5%;\r\n    padding-bottom: 3%;\r\n}\r\n\r\n.example-spacer {\r\n    flex: 1 1 auto;\r\n}\r\n\r\n.slideAdministrar {\r\n    margin-bottom: 10px;\r\n    font-weight: 500;\r\n}\r\n\r\n.fila1 {\r\n    padding-left: 5%;\r\n    padding-top: 5%;\r\n}\r\n\r\nh1{\r\n    font-size: x-large;\r\n}\r\n\r\n.col1 h1 {\r\n    width: 100%;\r\n    text-align: initial;\r\n    color: #333;\r\n    font-family: Roboto, Segoe UI, wf_segoe-ui_normal, helvetica, arial, sans-serif;\r\n    /* font-size: 14px;*/\r\n    font-size: 25px;\r\n    display: ruby-text-container;\r\n}\r\n\r\n.col2,\r\n.col3,\r\n.col1-3,\r\n.col4,\r\n.col5,\r\n.col6 {\r\n    text-align: end;\r\n    /*display: grid;\r\n    float: right;\r\n    border-bottom: 1px solid #cecece;*/\r\n    cursor: pointer;\r\n}\r\n\r\n@media screen and (max-width:990px) {\r\n    .col1 h1 {\r\n        font-size: 14px !important;\r\n    }\r\n}\r\n\r\ntable {\r\n    width: 100%;\r\n}\r\n\r\n.mat {\r\n    width: 100%;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.animacion {\r\n    width: 100%;\r\n    height: 90px;\r\n}\r\n\r\n.ocultar {\r\n    display: none !important;\r\n}\r\n\r\n.paginador {\r\n    display: ruby-text !important;\r\n    margin-left: 5%;\r\n}\r\n\r\n.tablaUsuarios {\r\n    border: 1px solid #cecece;\r\n}\r\n\r\n.inputBusqueda {\r\n    border-bottom: 2px solid #5b7f30;\r\n}\r\n\r\n.iconoBusqueda {\r\n    color: #8bc34a;\r\n    cursor: pointer;\r\n    padding-left: 8px;\r\n    width: 100%;\r\n}\r\n\r\n.matFile {\r\n    width: 100%;\r\n}\r\n\r\n.titulotabla {\r\n    text-align: center;\r\n    color: #333;\r\n    font-family: Roboto, Segoe UI, wf_segoe-ui_normal, helvetica, arial, sans-serif;\r\n    display: ruby-text-container;\r\n    width: 100%;\r\n}\r\n\r\n.divheader {\r\n    width: 100%;\r\n    text-align: start;\r\n}\r\n\r\n::ng-deep .mat-sort-header-button {\r\n    width: 100% !important;\r\n}\r\n\r\n// .mat ::ng-deep .mat-form-field-wrapper {\r\n//     padding-bottom: 0px !important;\r\n// }\r\n\r\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n}\r\n\r\n::ng-deep .form-tab-group {\r\n    \r\n    .mat-tab-body-wrapper {\r\n        padding: 2.5rem 0 0;\r\n    }\r\n}\r\n\r\n::ng-deep .mat-mdc-tab-group.mat-mdc-tab-group-stretch-tabs>.mat-mdc-tab-header .mat-mdc-tab {\r\n    font-size: 14px !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
